import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-10546a6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cuerpo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Contabilidad", -1))
const _hoisted_3 = { class: "cartas" }

import CardComponent from '../../components/PortalComponents/CardComponent.vue';    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'AccountingView',
  setup(__props) {

        
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CardComponent, {
        class: _normalizeClass('card-global'),
        image: "https://i.imgur.com/ek71Zlw.png",
        title: 'Reportes finacieros',
        content: 'Puedes registrar datos de la venta'
      }),
      _createVNode(CardComponent, {
        class: _normalizeClass('card-global'),
        image: "https://i.imgur.com/dtCGs9k.png",
        title: 'Generar certificados',
        content: 'Puedes ver el historial de tus ventas'
      })
    ])
  ]))
}
}

})